import { Link } from 'react-router-dom';

const categories = [
  {
    id: 'tshirts',
    title: 'Hilarious T-Shirts',
    tagline: '"The best tees in the known universe"',
    cta: 'Find Your Vibe',
    image: 'https://public.readdy.ai/ai/img_res/bcec7f08dc01b5b6bb61b22e4b6d44ff.jpg',
    path: '/contact',
    badge: 'Artist-Original',
    large: true,
  },
  {
    id: 'magic-dress',
    title: 'The Magic Dress',
    tagline: 'Moroccan-inspired, wearable 10+ ways',
    cta: 'See the Magic Dress',
    image: 'https://storage.readdy-site.link/project_files/6f4ffb53-7775-4bc5-81bd-7d8da9634b5b/7bff49a5-3081-4044-b68a-48052341eaff_YFVV4RES56LCAV26RM7BGMTW.webp?v=b08cc70394dd7e838ec479c3225bd4d8',
    path: '/contact',
    badge: 'Signature Piece',
    large: true,
  },
  {
    id: 'jackets',
    title: 'Goddess Jackets',
    tagline: 'Silk, velvet & beaded — plus-size inclusive',
    cta: 'Shop Jackets',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20beaded%20velvet%20silk%20jacket%20in%20deep%20jewel%20tones%20teal%20and%20gold%20close%20up%20detail%20shot%20boutique%20fashion%20warm%20lighting%20rich%20texture&width=600&height=400&seq=cat-jackets-001&orientation=landscape',
    path: '/contact',
    badge: 'Plus-Size Available',
    large: false,
  },
  {
    id: 'scarves',
    title: 'Scarves & Wraps',
    tagline: 'Flowing, colorful, endlessly versatile',
    cta: 'Shop Scarves',
    image: 'https://readdy.ai/api/search-image?query=colorful%20flowing%20silk%20scarves%20and%20wraps%20draped%20artistically%20warm%20golden%20light%20bohemian%20boutique%20display%20rich%20colors%20teal%20burgundy%20gold&width=600&height=400&seq=cat-scarves-001&orientation=landscape',
    path: '/contact',
    badge: null,
    large: false,
  },
  {
    id: 'drums',
    title: 'Metal Drums',
    tagline: 'Handcrafted rhythm for every soul',
    cta: 'Shop Drums',
    image: 'https://readdy.ai/api/search-image?query=handcrafted%20metal%20tongue%20drum%20steel%20drum%20artistic%20close%20up%20warm%20studio%20lighting%20musical%20instrument%20beautiful%20craftsmanship%20dark%20background%20golden%20tones&width=600&height=400&seq=cat-drums-001&orientation=landscape',
    path: '/contact',
    badge: null,
    large: false,
  },
  {
    id: 'music',
    title: 'Healing Music',
    tagline: 'Yoga, massage & relaxation — since 1981',
    cta: 'Explore Music',
    image: 'https://readdy.ai/api/search-image?query=peaceful%20yoga%20meditation%20music%20album%20covers%20arranged%20artistically%20warm%20candlelight%20atmosphere%20zen%20relaxation%20healing%20sound%20bowls%20crystals%20soft%20golden%20light&width=600&height=400&seq=cat-music-001&orientation=landscape',
    path: '/contact',
    badge: 'Est. 1981',
    large: false,
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-20 md:py-28" style={{ backgroundColor: '#F5F0E8' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <p style={{ fontFamily: '"Dancing Script", cursive', color: '#C9933A', fontSize: '1.3rem' }}>
            Something for every soul
          </p>
          <h2 style={{ fontFamily: '"Playfair Display", serif', color: '#4A3728' }} className="text-4xl md:text-5xl font-bold mt-1 mb-4">
            Our Collections
          </h2>
          <p style={{ fontFamily: '"Lato", sans-serif', color: '#7A5C42' }} className="text-base md:text-lg max-w-xl mx-auto">
            Curated with love, designed by artists, made for people who refuse to be boring.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Large cards — first two */}
          {categories.slice(0, 2).map((cat) => (
            <div
              key={cat.id}
              id={cat.id}
              className="relative overflow-hidden rounded-2xl group cursor-pointer"
              style={{ height: '420px' }}
            >
              <img
                src={cat.image}
                alt={cat.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              {cat.badge && (
                <span
                  className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide"
                  style={{ backgroundColor: '#C9933A', color: '#fff', fontFamily: '"Lato", sans-serif' }}
                >
                  {cat.badge}
                </span>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 style={{ fontFamily: '"Playfair Display", serif', color: '#fff' }} className="text-2xl font-bold mb-1">
                  {cat.title}
                </h3>
                <p style={{ fontFamily: '"Lato", sans-serif', color: '#EDE5D8' }} className="text-sm mb-4">
                  {cat.tagline}
                </p>
                <Link
                  to={cat.path}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-bold uppercase tracking-wide whitespace-nowrap transition-all duration-200 hover:-translate-y-0.5"
                  style={{ backgroundColor: '#C9933A', color: '#fff', fontFamily: '"Lato", sans-serif' }}
                >
                  {cat.cta}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}

          {/* Small cards — last four */}
          {categories.slice(2).map((cat) => (
            <div
              key={cat.id}
              id={cat.id}
              className="relative overflow-hidden rounded-2xl group cursor-pointer"
              style={{ height: '280px' }}
            >
              <img
                src={cat.image}
                alt={cat.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              {cat.badge && (
                <span
                  className="absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide"
                  style={{ backgroundColor: '#C9933A', color: '#fff', fontFamily: '"Lato", sans-serif' }}
                >
                  {cat.badge}
                </span>
              )}
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 style={{ fontFamily: '"Playfair Display", serif', color: '#fff' }} className="text-xl font-bold mb-1">
                  {cat.title}
                </h3>
                <p style={{ fontFamily: '"Lato", sans-serif', color: '#EDE5D8' }} className="text-xs mb-3">
                  {cat.tagline}
                </p>
                <Link
                  to={cat.path}
                  className="inline-flex items-center gap-1.5 text-sm font-bold whitespace-nowrap transition-colors duration-200 hover:text-[#E8B96A]"
                  style={{ color: '#E8B96A', fontFamily: '"Lato", sans-serif' }}
                >
                  {cat.cta} <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
